export default "__VITE_ASSET__f95af0f1__"